// What generating the Main Draw does to the event stage (RELEASE-TENIS10 § 11 P72, Tudor 2026-10-26: the admin is told that the event
// moves from Draw pending to Ready to play). The API publishes the draw when it is generated, never before registrations close nor
// after play starts (sportya-api Events/helpers/drawPublication.js), and the web shows it from Ready to play on.
const REGISTRATION_STAGES = ["openingSoon", "preRegistrationsOpen", "sortPending", "registrationsOpen"]
const PUBLISHED_STAGES = ["readyToPlay", "playing", "resultsPending", "ended"]

// { kind: "atRegistrationsClose", at } · { kind: "now" } · { kind: "unchanged", stage } · null (stage or registration close unknown)
export const drawPublicationNotice = (stage, phases) => {
  if (stage === "drawPending") return { kind: "now" }
  if (PUBLISHED_STAGES.includes(stage)) return { kind: "unchanged", stage }
  if (REGISTRATION_STAGES.includes(stage)) {
    const at = phases?.drawPending?.startDate ?? phases?.registrationsOpen?.endDate
    return at && Number.isFinite(new Date(at).getTime()) ? { kind: "atRegistrationsClose", at } : null
  }
  return null
}
